import { render, staticRenderFns } from "./StoreUsersEditBtn.vue?vue&type=template&id=f804bef8"
import script from "./StoreUsersEditBtn.vue?vue&type=script&lang=js"
export * from "./StoreUsersEditBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports